export default __webpack_public_path__ + "static/media/wordpress-step2.f7c47ec9.png";